// import logo from "../images/logo.svg";
import { ReactComponent as LogoImage } from "../images/logo-white.svg";
const Logo = () => (
  <div>
    {/* <img src={logo} alt="Logo" width="250" /> */}
    <LogoImage width="250" />
  </div>
);

export default Logo;
